exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2oOFwTVG8Cx7XUGlxARBrQ {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  max-width: 100%;\n  overflow-x: hidden;\n  height: 100%;\n}\n._2oOFwTVG8Cx7XUGlxARBrQ ._06naF7YImzNc97a2h9A- {\n  display: flex;\n  flex: 1;\n  background-color: #fff;\n  padding: 0;\n  overflow: hidden;\n}\n._2oOFwTVG8Cx7XUGlxARBrQ ._06naF7YImzNc97a2h9A- ._28sJumRRkY2Dovz-j8QmLk {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow: hidden;\n}\n", ""]);
// Exports
exports.locals = {
	"page": "_2oOFwTVG8Cx7XUGlxARBrQ",
	"content": "_06naF7YImzNc97a2h9A-",
	"pane": "_28sJumRRkY2Dovz-j8QmLk"
};